<!-- {{contact.payee_name}}
    
    <button type="button" (click)="showDialog()" icon="pi pi-info-circle" label="Show">Show Details</button> -->
    <div class="m-2">
    <div class="account-card account-card-primary">
        <p class="pirotry text-dark font-weight-bold text-right">Primary</p> 
        <div class="row">
            <p class="card-name col-12">{{ contact.payee_name }}<span class="contact-country">IN</span></p>
        </div>
        <div class="row card-contact">
            9898989854                                      
        </div>  
        <div class="row text-success detail">
            <small>Ghana</small>                                 
        </div>     
        <div class="row">
            <div class="col-8 d-flex flex-row mt-3">
                <button  class="btn btn-pay d-inline">Pay</button>
                <a (click)="showDialog()"><i class="fas fa-eye text-dark fa-2x pl-1"></i></a>
            </div>
            <div class="col-4">
                <img class="user-img" src="assets/images/user.png">
            </div>
            
        </div>
    </div>
</div>
    <p-dialog modal="true" [style]="{width: '40vw'}" header="Title" [(visible)]="display">
        {{contact.payee_name}}
        {{contact.recipient_id}}
    </p-dialog>